import { useState, useEffect, useRef, } from "react"
import { Link } from "react-router-dom";
import { Trash2, SquarePen, Eye, Search, Plus } from 'lucide-react';
import { Avatar, Stack } from '@chakra-ui/react'
import "./EmployeesMobileList.css"
import MobileNav from "../../../../defaultLayout/MobileNav";
export default function EmployeesMobileList(props) {
    const [selectedMobileTab, setSelectedMobileTab] = useState("All");
    const [showMobileNav, setShowMobileNav] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);
    const scrollRef = useRef(null);
    const { employeeData, openDrawer, openTrash, filterData, setDataToEdit, setIsUpdateMode, setDeleteEmployeeROWID, totalCount,  } = props;
    // scroll 
    const handleScroll = () => {
        if (scrollRef.current) {
            const currentScrollY = scrollRef.current.scrollTop; // Get scroll position from content
            console.log("Current scrollY in content: ", currentScrollY);
            if (currentScrollY > lastScrollY) {
                setShowMobileNav(false); // Scrolling down, hide MobileNav
            } else {
                setShowMobileNav(true); // Scrolling up, show MobileNav
            }

            setLastScrollY(currentScrollY); // Update the last scroll position
        }
    };
    useEffect(() => {
        const contentElement = scrollRef.current;

        if (contentElement) {
            contentElement.addEventListener('scroll', handleScroll); // Attach the scroll event to the content div
        }

        return () => {
            if (contentElement) {
                contentElement.removeEventListener('scroll', handleScroll); // Cleanup event listener
            }
        };
    }, [lastScrollY]);

    return (
        <div>
            <div className="d-flex justify-content-between tophead">
                <button onClick={() => setSelectedMobileTab("All")} className={`${selectedMobileTab === "All" ? "selected-tab" : "default-tab"} mx-2  position-relative `}>All</button>
                <span class="position-absolute  badge  p-1 " style={{ height: '20px', width: '20px', padding: '3px', display: 'inline-block', top: "12%", left: '6%', color: '#FF186C' }}>
                    <b>{totalCount}</b>
                </span>
                <span>
                    <Search className="search-icon" size="28px" strokeWidth="2" style={{ cursor: "pointer", marginRight: "15px" }}
                    />
                </span>
            </div>

            <div className=" p-2 employees-mobile-container" ref={scrollRef} >
                {/* employees card */}
                {/* <button class="employees-create-btn">  < Plus size={30} color="white" strokeWidth={3} /></button> */}

                {employeeData?.map((item, index) => (
                    <div className=" employeesCard rounded-4 mb-3 " key={index}>
                        <table className="rounded-4 employees-table" style={{ marginBottom: '0px', overflow: 'hidden' }} >
                            <tr>
                                <td
                                    style={{
                                        borderRight: "none",
                                        borderLeft: "none",
                                        borderTop: "none",
                                    }}
                                >
                                    <div className="w-100 d-flex align-items-center">
                                        <Stack direction='row' >
                                            <Avatar size='xl'  name={item?.employees?.employeeName} src='https://bit.ly/code-beast' boxSize={{ base: '35px', xl: '35px' }} 
                                              sx={{
                            "& .chakra-avatar__initials": {
                              fontSize: "1rem", // Adjust as needed
                              maxWidth: "35px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            },
                          }}
                                            />
                                        </Stack>
                                        <a href="https://web.whatsapp.com/" target="_blank" rel="noopener noreferrer">
                                            <img src="https://i.ibb.co/YBHqyr6f/whatsapp-2504957.png"
                                                alt="whatsapp-2504957" strokeWidth="1" className='ms-2' style={{ height: '25px', width: '25px' }} />
                                        </a>
                                    </div>
                                </td>
                                <td
                                    style={{
                                        borderRight: "none",
                                        borderLeft: "none",
                                        borderTop: "none",
                                    }}>
                                    <div className="w-100 d-flex justify-content-end align-items-center my-1 mt-3" style={{ height: '30px' }}>
                                        <Link to="/employee-detail-view" state={{ ROWID: item?.employees?.ROWID }}>
                                            <span style={{ cursor: "pointer" }} className="mx-2">
                                                <Eye color="#ff176b" size="20px" strokeWidth="1" />
                                            </span>
                                        </Link>
                                        <span className='ms-3 me-2' style={{ cursor: 'pointer' }}
                                            onClick={() => { openDrawer(item.employees); setDataToEdit(item.employees); setIsUpdateMode(true) }}>
                                            <SquarePen color="#ff176b" size="20px" strokeWidth="1" />
                                        </span>
                                        <span onClick={(e) => { openTrash(e); setDeleteEmployeeROWID(item?.employees?.ROWID) }}
                                            style={{ cursor: 'pointer' }} className='mx-2'>
                                            <Trash2 color="#ff176b" size="20px" strokeWidth="1" />
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                        <td className="p-2" style={{ borderTop: "none", borderLeft: "none" }}>
                        <p className="mb-1 employees-desc">
                          <b>{item?.employees?.employeeName || "NA"}</b>
                        </p>
                    </td>     
                     <td className="p-2" style={{ borderTop: "none", borderLeft: "none", borderRight:"none" }}>
                        <p className="mb-1 employees-desc">
                          {item?.employees?.email || "NA"}
                        </p>
                    </td>                                       
                    </tr>
                    <tr>         
                    <td className="p-2" style={{ borderTop: "none", borderLeft: "none" , borderBottom:"none"}}>
                    <p className="mb-1 employees-desc">
                    {item?.employees?.phoneNumber || "NA"}
                    </p>
                    </td>   
                    <td className="p-2" style={{ borderTop: "none", borderLeft: "none", borderBottom:"none", borderRight: "none",}}>
                    <p className="mb-1 employees-desc">
                    {item?.employees?.startDate || "NA"}
                    </p>
                    </td>  

                            
                            </tr>

                        </table>

                    </div>
                ))}
                <button onClick={openDrawer} className={`lead-create-btn  ${showMobileNav === true ? "" : "d-none"}`} >
                    <Plus size={30} onClick={openDrawer} style={{ color: 'white' }} />
                </button>
                {showMobileNav && (
                    <div className='d-block d-sm-block d-lg-none d-md-none'>
                        <MobileNav/>
                    </div>
                )}


            </div>

        </div>
    )
}
